import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  IconButton,
  Typography,
  
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import { StockAdjustmentRo } from "../../../Redux/roStore";
import { fcheck_null_undefine_replace_empty } from "../../../Utility/Utilitys";
 
import {   inv04_RefDocumentNo_GETROW } from "../../../Server/ApiV2";
 
import moment from "moment";
import { CmpDatePickerField, CmpInputField } from "../../../Component/Common/ToolBox/ToolBox";

const ReqDocumentSearchModal = ({
  open,
  onClose,
  defaultValue = {
    FromLocation:"",
    ToLocation:"",
    FromLocationCd:"",
    ToLocationCd:"",
  },
  handleRowClick, 
  title="Location Search"
}) => {
  const [anyData, setAnyData] = useState(defaultValue); 
  const [sFromDate, setFromDate] = useState(new Date());
  const [sToDate, setToDate] = useState(new Date());
  const [gridData, setGridData] = useState([]); // Grid data state
  const dataGridRef = useRef(); // Ref to handle DataGrid focus

  // Handle input change
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };

  // Handle Clear action
  const handleClear = () => {
   
    setFromDate(new Date());
    setToDate(new Date());

    setGridData([]);
  };

  // Trigger API call when the Enter key is pressed
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLoad(); // Call API when Enter is pressed
    }
    if (e.keyCode === 40 && gridData.length > 0) {
      fCheckKey(e);
    }
  };

  // Handle both Enter key for API call and Arrow Down for focusing the grid
  const fCheckKey = (event) => {
    setTimeout(() => {
      if (event.keyCode === 40 && gridData.length > 0) {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let table = document.getElementById("table-main-grid");
          table
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }
    }, 500);
  };
  const handleLoad = async () => {
    const { HeadObject } =StockAdjustmentRo();
    const payload = {
      v_Loc:   anyData.FromLocationCd,
      v_LocTo: anyData.ToLocationCd, 
      v_Date1:  moment(sFromDate).format("YYYY-MM-DD"),
      v_Date2: moment(sToDate).format("YYYY-MM-DD"),
    };
    let resp = await inv04_RefDocumentNo_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
              Name1: obj.A_VocNo[0],
              UID: obj.A_VocNo[0]
            }));

      setGridData(respData);
    } else {
      setGridData([]);
    }
  };

  useEffect(() => {
    // Add keydown listener for arrow navigation
    if (open && defaultValue != "") {
      handleLoad();
    }
    setAnyData(defaultValue);
  }, [open]);

  // useEffect(() => {
  //   // Add keydown listener for arrow navigation
  //   window.addEventListener("keydown", fCheckKey);
  //   return () => {
  //     window.removeEventListener("keydown", fCheckKey);
  //   };
  // }, [gridData]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* Adjusted Title with Proper Icon Alignment */}
      <DialogTitle
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          padding: "8px 16px",
          display: "flex", // Use flex to align items
          alignItems: "center", // Vertically center
          justifyContent: "space-between", // Push title to the left and icon to the right
          minHeight: "20px", // Adjust title height to 20px
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ fontSize: "1rem", lineHeight: "20px" }} // Match height with title
        >
      {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "white",
            padding: "0", // Remove extra padding
            marginLeft: "auto", // Align to the right
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "24px", // Add some padding to the content for better spacing
          marginTop: 3,
        }}
      >
        {/* Input Fields */}
        <Grid container spacing={2} alignItems="center">
        <Grid item xs={2} sm={2}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
            From Code
            </Typography>
             
             <CmpInputField
                xtabIndex={"6"}
                xValue={anyData.FromLocationCd}
                xType={"text"} // text/number/password
                xName={"FromLocationCd"}
                xReadOnly={true} 
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
          </Grid>
          <Grid item xs={4} sm={3}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
            From Location
            </Typography>
             
             <CmpInputField
                xtabIndex={"6"}
                xValue={anyData.FromLocation}
                xType={"text"} // text/number/password
                xName={"FromLocation"}
                xReadOnly={true} 
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
          </Grid>
          <Grid item xs={2} sm={2}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
              To Code
            </Typography>
            
             <CmpInputField
                xtabIndex={"6"}
                xValue={anyData.ToLocationCd}
                xType={"text"} // text/number/password
                xName={"ToLocationCd"}
                xReadOnly={true} 
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
          </Grid>
          <Grid item xs={4} sm={3}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
              To Location
            </Typography>
            
             <CmpInputField
                xtabIndex={"6"}
                xValue={anyData.ToLocation}
                xType={"text"} // text/number/password
                xName={"FromLocation"}
                xReadOnly={true} 
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
              />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
             From Date
            </Typography>
             
             <CmpDatePickerField
                xtabIndex={"2"}
                xValue={sFromDate}
                xOnChange={(event)=>{ 
                  if (
                    event?.$d == "Invalid Date" ||
                    event?.$d == null ||
                    event?.$d === undefined ||
                    event?.$d === ""
                  ) {
                    setFromDate("")
                  } else {
                    setFromDate( event?.$d)
                    
                  }
                }}
                xName={"sFromDate"} 
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography
              variant="h6"
              component="div"
              sx={{ fontSize: "0.8rem", lineHeight: "20px" }} // Match height with title
            >
             To Date
            </Typography>
             
             <CmpDatePickerField
                xtabIndex={"2"}
                xValue={sToDate}
                xOnChange={(event)=>{
                  
                  if (
                    event?.$d == "Invalid Date" ||
                    event?.$d == null ||
                    event?.$d === undefined ||
                    event?.$d === ""
                  ) {
                    setToDate("")
                  } else {
                    setToDate( event?.$d)
                    
                  }
                }}
                xName={"sToDate"} 
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
          </Grid>
         
        </Grid>

        {/* DataGrid for displaying search results */}
        <div
          id="table-main-grid"
          ref={dataGridRef}
          style={{ height: 300, width: "100%", marginTop: 20 }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            rows={gridData}
            columns={[
              { field: "UID", headerName: "Code", width: 150 },
              { field: "Name1", headerName: "Name", width: 150 },
            ]}
            pageSize={5}
            disableSelectionOnClick
            hideFooter={gridData.length < 100}
            onRowClick={handleRowClick}
          />
        </div>
      </DialogContent>

      <DialogActions
        sx={{ padding: "16px", marginTop: "16px" }} // Add padding and margin-top for better spacing
      >
        <Button variant="contained" onClick={handleLoad}>
          Load
        </Button>
        <Button variant="contained" onClick={handleClear} color="warning">
          Clear
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReqDocumentSearchModal;
